import React, {useEffect, useState, useRef} from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../Services/auth.service";
//
import UserService from "../Services/user.service";

import registerlogo from '../Assets/Images/dacminott.png';

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Questo campo è richiesto
      </div>
    );
  }
};

const vuseremail = value => {
  if (value.length < 3 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        L'e-mail deve essere compresa tra 3 e 40 caratteri
      </div>
    );
  }
};

const vfirstname = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        Il nome deve essere compreso tra i 3 ed i 20 caratteri
      </div>
    );
  }
};

const vlastname = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        Il cognome deve essere compreso tra i 3 ed i 20 caratteri
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        The password must be between 6 and 40 characters.
      </div>
    );
  }
};

const Register=(props)=> {

  const form = useRef();
  const checkBtn = useRef();
  const [useremail, setuseremail]= useState("");
  const [firstname, setfirstname]= useState("");
  const [lastname, setlastname]= useState("");
  const [password, setpassword]= useState("");
  const [successful, setsuccessful]= useState(false);
  const [message, setmessage]= useState("");
  ///
  const [usercode, setnumuser]= useState(0);

  useEffect(() => {
    UserService.getNumberUsers().then(
      (response) => {
        setnumuser(parseInt(response.data)+101);
        console.log(response.data)
      }
    );
  }, []);

  const clearinputs=()=>{
    setfirstname();
    setlastname();
    setuseremail();
    setpassword();
  }
  const onChangeUseremail=(e)=> {
    setuseremail(e.target.value);
  }

  const onChangeFirstname=(e)=> {
    setfirstname(e.target.value);
  }

  const onChangeLastname=(e)=> {
    setlastname(e.target.value);
  }

  const onChangePassword=(e)=> {
    setpassword(e.target.value);
  }

  const handleRegister=(e)=> {
    e.preventDefault();

    setmessage("");
    setsuccessful(false);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.register(useremail, firstname, lastname, password, usercode)
      .then(
        res => {
            setmessage(res.data.message);
            setsuccessful(true);
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

            setsuccessful(false);
            setmessage(resMessage);
            clearinputs();//messo per pulire gli inputs ma se non va lo tolgo
        }
      );
    }
  }

    return (
      <div className="col-md-12">
        <div className="card card-container">
          <img
            src={registerlogo}
            alt="profile-img"
            className="profile-img-card"
          />

          <Form onSubmit={handleRegister} ref={form}>
            {!successful && (
              <div>
                <div className="form-group">
                  <label htmlFor="useremail">E-Mail</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="useremail"
                    value={useremail}
                    onChange={onChangeUseremail}
                    validations={[required, vuseremail]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="firstname">Nome</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="firstname"
                    value={firstname}
                    onChange={onChangeFirstname}
                    validations={[required, vfirstname]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="lastname">Cognome</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="lastname"
                    value={lastname}
                    onChange={onChangeLastname}
                    validations={[required, vlastname]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password"
                    value={password}
                    onChange={onChangePassword}
                    validations={[required, vpassword]}
                  />
                </div>

                <div>
                  <label value={usercode}></label>
                </div>  


                <div className="form-group">
                  <button 
                    className="btn btn-block"
                    style={{backgroundColor:'#090979', color:'white'}}
                  >Sign Up</button>
                </div>
              </div>
            )}

            {message && (
              <div className="form-group">
                <div
                  className={
                    successful
                      ? "alert alert-success"
                      : "alert alert-danger"
                  }
                  role="alert"
                >
                  {message}
                </div>
              </div>
            )}
            <CheckButton style={{ display: "none" }} ref={checkBtn}/>
          </Form>
        </div>
      </div>
    );
}

export default Register;